import { render, staticRenderFns } from "./DropdownSelection.vue?vue&type=template&id=532ee0b5"
import script from "./DropdownSelection.vue?vue&type=script&lang=js"
export * from "./DropdownSelection.vue?vue&type=script&lang=js"
import style0 from "./DropdownSelection.vue?vue&type=style&index=0&id=532ee0b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports